module.exports = __webpack_public_path__ + "img/butterfly.5971edfc.png";